import { useCallback, useContext } from 'react'

import AppContext from '../../context/appContext'
import { processLoadingWithConfirmation } from './processLoading'
import {
  contactSupportReasons,
  displayErrorMessageModes,
} from '../../components/GlobalLoadingModal/GlobalLoadingModal'

export function useProcessLoadingWithConfirmation() {
  const { setPartialChanges, setLoadingModalConfig, setConfirmationModalConfig } =
    useContext(AppContext)

  const handleProcessLoadingWithConfirmation = useCallback(
    async ({
      doAction,
      confirmationTitle,
      confirmationMessage,
      loadingMessage,
      errorMessage,
      successfulMessage = '',
      contactReasonSupportType = contactSupportReasons.Generic,
    }) => {
      return processLoadingWithConfirmation({
        setPartialChanges,
        loadingModalConfig: {
          setLoadingModalConfig,
          loadingMessage,
          contactReasonSupportType,
          errorMessage,
          displayErrorMessageMode: displayErrorMessageModes.dialog,
          successfulMessage,
        },
        confirmationModalConfig: {
          setConfirmationModalConfig,
          title: confirmationTitle,
          message: confirmationMessage,
        },
        doAction,
      })
    },
    [setConfirmationModalConfig, setLoadingModalConfig, setPartialChanges],
  )

  return { processLoadingWithConfirmation: handleProcessLoadingWithConfirmation }
}
